import axios from "axios";
import { SERVER_URL } from "Constants";
import useAsync from "Hooks/useAsync";
import { AlaresReport } from "Models/Interfaces/AlaresReport";
import { AtoDefaultSummary } from "Models/Interfaces/AtoDefaultSummary";

type UseCustomerAlaresReportArgs = {
	customerId?: string,
}

export default function useCustomerAlaresReport(args: UseCustomerAlaresReportArgs) {
	const { customerId } = args;

	const request = useAsync(async () => {

		// Guard 1: no id
		if (customerId === undefined) return null;
		const { data } = await axios.get(`${SERVER_URL}/api/entity/AlaresReportEntity/report/${customerId}`);
		
		// Guard 2: no report for customer
		if (data === null) return null;

		const responseData = data as { alaresReport: AlaresReport, atoDefaults: AtoDefaultSummary[] };
		const report = responseData.alaresReport;

		return {
			report: report,
			atoDefaults: responseData.atoDefaults
		};
	}, [customerId]);
	
	return request;
}